/**
 * 编辑学生信息 */
export default {
	state: {
		studentInfo: null,
	},
	mutations: {
		setStudentInfo(state, payload) {
			state.studentInfo = payload;
			if (window.localStorage) {
				window.localStorage.studentInfo = JSON.stringify(state.studentInfo);
			}
		},
		initStudentInfo(state) {
			if (window.localStorage && window.localStorage.studentInfo) {
				state.studentInfo = JSON.parse(window.localStorage.studentInfo);
			}
		},
	},
	getters: {},
};
